// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as Scrollable$Showside from "./Scrollable.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import ReactVisibilitySensor from "react-visibility-sensor";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as MobilePhotoSlider$Showside from "./MobilePhotoSlider.bs.js";
import * as PDPContentDetails$Showside from "./PDPContentDetails.bs.js";
import * as DesktopPhotoSlider$Showside from "./DesktopPhotoSlider.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function PDPContent(Props) {
  var product = Props.product;
  var variant = Props.variant;
  var productCategory = Props.productCategory;
  var shouldForceMobile = Props.shouldForceMobile;
  var isInsideQuickView = Props.isInsideQuickView;
  var viewport = Props.viewport;
  var scrollableContainerRef = Props.scrollableContainerRef;
  var scrollToRef = Props.scrollToRef;
  var showMoreProducts = Props.showMoreProducts;
  var renderLauncher = Props.renderLauncher;
  var match = ConfigurationProvider$Showside.use(undefined).config;
  var settings = match.settings;
  var match$1 = ViewportContext$Showside.use(undefined);
  var breakpoint = match$1.breakpoint;
  var entrypointContext = EntrypointContext$Showside.use(undefined);
  var trackEvent = entrypointContext.trackEvent;
  var embedType = entrypointContext.embedType;
  var match$2 = RouterProvider$Showside.useRouter(undefined);
  var productCategoryId = match$2.productCategoryId;
  var variantId = match$2.anyVariantId;
  var goTo = match$2.goTo;
  var route = match$2.route;
  var isMobile = match$1.isMobile || shouldForceMobile;
  var selectedVariant = Belt_Option.flatMap(variantId, function (param) {
    return Product$Showside.getVariantById(product, param);
  });
  var hideMediaFromOtherVariants = Belt_Option.mapWithDefault(match.transitiveAccount, false, function (account) {
    return account.pdpHideMediaFromOtherVariants;
  });
  var allVariantMedia = React.useMemo(function () {
    var variant = Belt_Option.getWithDefault(selectedVariant, product.firstVariant);
    return Product$Showside.getAllVariantMedia(hideMediaFromOtherVariants, product, variant);
  }, [Belt_Option.map(selectedVariant, function (v) {
    return v.id;
  }), product.id]);
  var photoSliderVisibleRef = React.useRef(true);
  var ctaVisibleRef = React.useRef(/* Visible */3);
  var stickyDetailsRef = React.useRef(function (visible) {});
  var onPhotoSliderVisibilityChange = React.useCallback(function (visible) {
    photoSliderVisibleRef.current = visible;
    Curry._1(stickyDetailsRef.current, ctaVisibleRef.current !== /* Visible */3 && !photoSliderVisibleRef.current);
  }, [photoSliderVisibleRef, ctaVisibleRef]);
  var onCTAButtonVisibilityChange = React.useCallback(function (visible) {
    ctaVisibleRef.current = visible;
    Curry._1(stickyDetailsRef.current, ctaVisibleRef.current !== /* Visible */3 && !photoSliderVisibleRef.current);
  }, [photoSliderVisibleRef, ctaVisibleRef]);
  var onPhotoZoomed = React.useCallback(function (index) {
    if (typeof route !== "number") {
      switch (route.TAG | 0) {
        case /* PDP */2:
          var match = route._0;
          return Curry._3(goTo, undefined, true, {
            TAG: /* PDP */2,
            _0: {
              categoryId: match.categoryId,
              productCategoryId: productCategoryId,
              productId: match.productId,
              variantId: variantId,
              zoomedPhotoIndex: index
            }
          });
        case /* QuickView */3:
          var payload = route._0;
          return Curry._3(goTo, undefined, undefined, {
            TAG: /* QuickView */3,
            _0: {
              mediaId: payload.mediaId,
              mediaParentId: payload.mediaParentId,
              albumId: payload.albumId,
              productId: payload.productId,
              relatedMediaProductIds: payload.relatedMediaProductIds,
              relatedMediaCategoryId: payload.relatedMediaCategoryId,
              variantId: payload.variantId,
              panelClosed: payload.panelClosed,
              zoomedPhotoIndex: index,
              time: payload.time
            }
          });
        default:
      }
    }
    Curry._3(goTo, undefined, true, {
      TAG: /* PDP */2,
      _0: {
        categoryId: productCategory.id,
        productCategoryId: productCategoryId,
        productId: product.id,
        variantId: variant.id,
        zoomedPhotoIndex: index
      }
    });
  }, [RouterProvider$Showside.toString(route), productCategoryId]);
  var onSlideChange = function (param) {
    Curry.app(trackEvent, ["product details:image scroll", undefined, undefined, product, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
  };
  var onClickThumbnail = function (param) {
    Curry.app(trackEvent, ["product details:image select", undefined, undefined, product, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
  };
  var variant$1 = Belt_Option.getWithDefault(selectedVariant, product.firstVariant);
  var desktopPhotoContent = React.createElement(ConditionalRender$Showside.When.make, {
    condition: !isMobile,
    children: React.createElement("div", {
      className: CSS$Showside.prefix("all w-full relative")
    }, React.createElement(DesktopPhotoSlider$Showside.make, {
      product: product,
      variantId: variant$1.id,
      medias: allVariantMedia,
      viewport: viewport,
      onPhotoZoomed: onPhotoZoomed,
      onSlideChange: onSlideChange,
      onClickThumbnail: onClickThumbnail
    }))
  });
  var variant$2 = Belt_Option.getWithDefault(selectedVariant, product.firstVariant);
  var onSlideChange$1 = React.useCallback(function (param) {
    Curry.app(trackEvent, ["product details:image scroll", undefined, undefined, product, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
  }, [product.id, trackEvent]);
  var onClickImage = React.useCallback(function (param) {
    Curry.app(trackEvent, ["product details:image select", undefined, undefined, product, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
  }, [product.id, trackEvent]);
  var mobilePhotoContent = React.createElement(ConditionalRender$Showside.When.make, {
    condition: isMobile,
    children: React.createElement(ReactVisibilitySensor, {
      partialVisibility: true,
      onChange: onPhotoSliderVisibilityChange,
      children: React.createElement("div", {
        className: CSS$Showside.prefix("flex-shrink-0")
      }, React.createElement(MobilePhotoSlider$Showside.make, {
        product: product,
        productId: product.id,
        variantId: variant$2.id,
        medias: allVariantMedia,
        fitToContainer: settings.productCardFitToContainer,
        onPhotoZoomed: onPhotoZoomed,
        onClickImage: onClickImage,
        onSlideChange: onSlideChange$1,
        onClickThumbnail: onClickThumbnail,
        viewport: viewport,
        settings: settings,
        productCategory: productCategory
      }))
    })
  });
  var scrollableCn = isMobile && embedType === /* Bottombar */0 ? CSS$Showside.prefix("-mt-5") : "";
  var scrollableStyle = isMobile && embedType === /* Bottombar */0 ? {
    height: "calc(100% + 14px)"
  } : undefined;
  var widthCn = breakpoint !== 2 ? breakpoint >= 3 ? "w-146" : "" : "w-120";
  var scrollToDetailsRef = React.useRef(function (param) {
    Curry._1(scrollToRef.current, /* Top */0);
  });
  var tmp = {
    restorationId: isInsideQuickView ? "qv-pdp" : "nav-pdp",
    scrollToRef: scrollToRef,
    children: null,
    fwdRef: scrollableContainerRef,
    className: scrollableCn,
    rememberScrollPosition: false
  };
  if (scrollableStyle !== undefined) {
    tmp.style = Caml_option.valFromOption(scrollableStyle);
  }
  var tmp$1 = {
    product: product,
    variant: variant,
    productCategory: productCategory,
    shouldForceMobile: shouldForceMobile,
    isInsideQuickView: isInsideQuickView,
    scrollableContainerRef: scrollableContainerRef,
    scrollToDetailsRef: scrollToDetailsRef,
    stickyDetailsRef: stickyDetailsRef,
    descriptionLayout: /* Accordion */1,
    onCTAButtonVisibilityChange: onCTAButtonVisibilityChange,
    stickyCTA: !isMobile
  };
  if (showMoreProducts !== undefined) {
    tmp$1.showMoreProducts = Caml_option.valFromOption(showMoreProducts);
  }
  var rightColumn = React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make([isMobile ? "" : "relative flex-shrink-0", widthCn]))
  }, React.createElement(Scrollable$Showside.make, tmp, Belt_Option.mapWithDefault(renderLauncher, null, function (fn) {
    return Curry._1(fn, CSS$Showside.prefix("py-4"));
  }), React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["flex", isMobile ? "flex-col relative" : "flex-row w-full"]))
  }, mobilePhotoContent, React.createElement("div", {
    className: CSS$Showside.prefix("flex flex-col flex-grow w-full")
  }, React.createElement(PDPContentDetails$Showside.make, tmp$1)))));
  return React.createElement(DataAttribute$Showside.make, {
    dataTestId: "pdp",
    children: React.createElement("div", {
      className: CSS$Showside.prefix("absolute inset-0 bg-main")
    }, React.createElement("div", {
      className: CSS$Showside.prefix("flex flex-col h-full")
    }, React.createElement("div", {
      className: CSS$Showside.prefix("flex-grow flex")
    }, desktopPhotoContent, rightColumn)))
  });
}
PDPContent.displayName = "PDPContent";
var make = React.memo(PDPContent);
export { make };
/* make Not a pure module */